import { useState, useEffect } from "react";
import { fetchOnlyProducts } from "../../../services/product.service";
import { useSelector, useDispatch } from "react-redux";

import ProductTable from "../../../Components/BoltTable/BoltTable";
import Tooltips from "../../../Components/Tooltip/Tooltip";
import { showSnackBar } from "../../../store/common/snackBarSlice";
import noImage from "../../../assets/images/noImage.png";

import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import IconButton from "@mui/material/IconButton";
import { IoInformationCircleOutline } from "react-icons/io5";
import { PiPackageLight } from "react-icons/pi";
import { useTranslation } from "react-i18next";

export default function ProductScroller(props) {
  const { t } = useTranslation("sales");
  const {
    data,
    setData,
    SelectedProducts,
    setSelectedProducts,
    Warehouse,
    setWarehouse,
    editMode,
  } = props;
  const dispatch = useDispatch();
  const user = useSelector((state) => state.user);
  const [Products, setProducts] = useState();

  const columns = [
    {
      id: 1,
      label: " ",
      render: (row) => (
        <img
          src={ImageUrl(row)}
          onError={(e) => {
            e.target.src = noImage;
          }}
          loading="lazy"
          style={{ maxWidth: "100%" }}
        />
      ),
      fixed: "left",
      width: "2vw",
    },
    {
      id: 2,
      label: t("name"),
      render: (row) => (
        <>
          <div className="ship__page_myproduct_listing_bolt_table_name">
            {row.name ?? "-"}
          </div>
        </>
      ),
      width: "15vw",
    },
    {
      id: 3,
      label: t("sku"),
      render: (row) => <>{row.code ?? "-"}</>,
      width: "15vw",
    },
    {
      id: 4,
      label: t("dimensionsLWH"),
      render: (row) => (
        <>
          <div className="product_dimension_parent_wrapper">
            <div>
              {row?.length ?? "0"}*{row?.width ?? "0"}*{row?.height ?? "0"} (
              {row?.dimension_unit?.toUpperCase() ?? "N/A"})
            </div>
            <div className="product__notification_circle_wrapper">
              <PiPackageLight size={10} />
              {row?.package_details &&
                Object?.values(row?.package_details)?.length > 0 && (
                  <div className="product__notification_circle">
                    {Object.values(row?.package_details)?.length}
                  </div>
                )}
            </div>
          </div>
        </>
      ),
      width: "5vw",
    },
    {
      id: 5,
      label: t("weight"),
      render: (row) => (
        <>
          {row?.weight ?? "0"} {row?.weight_unit}
        </>
      ),
      width: "5vw",
    },
    {
      id: 6,
      label: t("quantity"),
      render: (row) => (
        <>
          {row?.product_warehouse?.reduce(
            (total, warehouse) => total + parseInt(warehouse.quantity, 10) || 0,
            0
          )}
        </>
      ),
      width: "3vw",
    },
  ];

  const warehouses = user?.user_approved_warehouses;
  const insertIndex = columns.length;
  warehouses?.forEach((warehouse, index) => {
    columns.splice(insertIndex, 0, {
      id: 1000 + index,
      label: warehouse?.warehouse?.name,
      render: (row) => {
        const matchedWarehouse = row?.product_warehouse?.find(
          (item) => item?.warehouse_id == warehouse?.warehouse_id
        );

        return (
          <>
            {matchedWarehouse && (
              <>
                {
                  <div
                    className="product__textalign_center"
                    style={{
                      fontWeight:
                        matchedWarehouse?.warehouse_id == Warehouse
                          ? "bold"
                          : "",
                    }}
                  >
                    {matchedWarehouse?.quantity ?? "-"}
                  </div>
                }
              </>
            )}
          </>
        );
      },
      width: "5vw",
    });
  });

  const ImageUrl = (row) => {
    const url =
      row?.media.find((media) => media.is_primary === "true")?.file ||
      row?.media[0]?.file;
    return url || noImage;
  };

  const handleChange = (e) => {
    // setSelectedProducts([]);
    setWarehouse(e.target.value);
  };

  const getAllProducts = async (page, perPage, filter) => {
    const response = await fetchOnlyProducts(page, perPage, filter);
    if (!response.error) {
      setProducts(response?.data?.result);
    } else {
    }
  };

  const handlescrollpackage = (data) => {
    if (!Warehouse) {
      dispatch(
        showSnackBar({
          text: t("selectAWarehouse"),
          severity: "info",
        })
      );
      return;
    }
    dispatch(
      showSnackBar({
        text: t("productAdded", { name: data?.name ?? t("productFallback") }),
        severity: "success",
      })
    );
    const productId = data.id;

    const existingProductIndex = SelectedProducts.findIndex(
      (product) => product.id === productId
    );

    if (existingProductIndex !== -1) {
      const updatedProducts = [...SelectedProducts];
      updatedProducts[existingProductIndex].quantity += 1;
      setSelectedProducts(updatedProducts);
    } else {
      const newData = { ...data, quantity: 1 };
      setSelectedProducts([...SelectedProducts, newData]);
    }
  };

  useEffect(() => {
    setData({ ...data, items: SelectedProducts });
  }, [SelectedProducts]);

  return (
    <div className="custom__table_size1 actionbtn__needtobe_fixwidth">
      <ProductTable
        tableTitle={t("products")}
        tableId="productListViewTableforShipper"
        message={t("noProductsAvailableToDisplay")}
        searchPlaceHolder={t("searchProducts")}
        getAllData={getAllProducts}
        data={Products}
        columns={columns}
        handleRowClick={handlescrollpackage}
        disableAutoResizing={true}
        isRowClick={Warehouse ? t("clickToAdd") : t("selectWarehouse")}
        headerButtons={
          <div className="flex gap-1 flex-wrap">
            <div className="relative w-full">
              <Select
                id="warehouse-select"
                value={Warehouse ?? ""}
                onChange={handleChange}
                displayEmpty
                inputProps={{ "aria-label": t("selectWarehouse") }}
                sx={{
                  width: "100%",
                  height: "40px",
                  fontSize: "14px",
                  paddingRight: "60px", // Give enough space for both icons
                  "& .MuiSelect-select": {
                    padding: "8px 12px",
                  },
                  "& .MuiSelect-icon": {
                    right: "8px", // Keep dropdown icon on far right
                  },
                }}
              >
                <MenuItem value="" disabled>
                  {t("selectWarehouse")}
                </MenuItem>
                {user?.user_approved_warehouses?.map((warehouse, index) => (
                  <MenuItem value={warehouse?.warehouse_id} key={index}>
                    #{warehouse?.warehouse_id} : {warehouse?.warehouse?.name}
                  </MenuItem>
                ))}
              </Select>

              {/* Info Icon Positioned Before Dropdown Arrow */}
              <div className="absolute right-8 top-1/2 transform -translate-y-1/2">
                {!Warehouse ? (
                  <Tooltips title={t("selectAWarehouse")} placement="top">
                    <IconButton size="small">
                      <IoInformationCircleOutline size={15} />
                    </IconButton>
                  </Tooltips>
                ) : (
                  <Tooltips
                    title={t("switchWarehouseHint")}
                    placement="top"
                  >
                    <IconButton size="small" className="text-brand">
                      <IoInformationCircleOutline size={15} />
                    </IconButton>
                  </Tooltips>
                )}
              </div>
            </div>
          </div>
        }
      />
    </div>
  );
}
